/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Auto_Offset_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Offset" |
*
* @param {Subtitle_Import_Auto_Offset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_auto_offset_title = /** @type {((inputs?: Subtitle_Import_Auto_Offset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Auto_Offset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decalage automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatischer Offset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое смещение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動オフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित ऑफसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento automático")
	return /** @type {LocalizedString} */ ("Automatic Offset")
});